export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col" aria-labelledby="hero-heading">
      {/* Static wayfinding labels - purely decorative, not interactive */}
      <div className="w-full flex items-center justify-end gap-12 px-10 md:px-16 py-6" role="presentation">
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500 font-label whitespace-nowrap">Engineering</span>
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500 font-label whitespace-nowrap">Philosophy</span>
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500 font-label whitespace-nowrap">Capabilities</span>
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500 font-label whitespace-nowrap">Contact</span>
      </div>

      {/* 50-50 split */}
      <div className="flex-1 flex flex-col lg:flex-row">
        {/* Left panel - white background */}
        <div className="w-full lg:w-1/2 flex items-center bg-background-50 px-10 md:px-16 lg:px-20 py-16 lg:py-0">
          <div className="w-full max-w-xl">
            <h1 id="hero-heading" className="font-heading text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.95] text-foreground-950 font-bold tracking-tight">
              Sivora Apps LLC
            </h1>
            <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-600 font-normal italic mt-4 leading-tight">
              Professional iOS Engineering
            </p>
            <div className="mt-10 md:mt-12 lg:mt-16" role="presentation" style={{ height: 80 }}></div>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg font-body font-light">
              A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
            </p>
          </div>
        </div>

        {/* Right panel - warm beige with abstract geometric glyph */}
        <div className="w-full lg:w-1/2 relative overflow-hidden bg-[#f3efe8] flex items-center justify-center min-h-[400px] lg:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20featuring%20overlapping%20circles%20and%20curved%20lines%20in%20warm%20beige%20and%20cream%20tones%20on%20a%20light%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20no%20text%2C%20architectural%20line%20art%20style%2C%20soft%20subtle%20contrast%2C%20elegant%20abstract%20design%20with%20flowing%20geometric%20shapes%20creating%20visual%20texture%20without%20representational%20elements&width=900&height=1080&seq=sivora-hero-glyph&orientation=portrait"
            alt="Abstract geometric composition representing modern engineering design principles"
            title="Sivora Apps LLC - Engineering Design"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}